import { render, staticRenderFns } from "./ExtendedMemberRevokeAlert.vue?vue&type=template&id=afb02cf2"
import script from "./ExtendedMemberRevokeAlert.vue?vue&type=script&lang=js"
export * from "./ExtendedMemberRevokeAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports